import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.scss';
import logo from '../assets/images/logo/devsecops_logo.png';
import ShoppingCart from './ShoppingCart/ShoppingCart';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navigation">
      <div className="container">
        <Link to="/" className="navigation__logo">
          <img src={logo} alt="DevSecOps Logo" />
          <span>DevSecOps</span>
        </Link>

        <button
          className="navigation__hamburger"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navigation__content ${isMenuOpen ? 'is-open' : ''}`}>
          <div className="navigation__links">
            <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={toggleMenu}>
              Home
            </Link>
            <Link
              to="/services"
              className={location.pathname === '/services' ? 'active' : ''}
              onClick={toggleMenu}
            >
              Services
            </Link>
            <Link
              to="/solutions"
              className={location.pathname.includes('/solutions') ? 'active' : ''}
              onClick={toggleMenu}
            >
              Solutions
            </Link>
            <Link
              to="/products"
              className={location.pathname.startsWith('/products') ? 'active' : ''}
              onClick={toggleMenu}
            >
              Products
            </Link>
            <Link
              to="/case-studies"
              className={location.pathname === '/case-studies' ? 'active' : ''}
              onClick={toggleMenu}
            >
              Case Studies
            </Link>
            <Link
              to="/blog"
              className={location.pathname === '/blog' ? 'active' : ''}
              onClick={toggleMenu}
            >
              Blog
            </Link>
            <Link
              to="/contact-us"
              className={location.pathname === '/contact-us' ? 'active' : ''}
              onClick={toggleMenu}
            >
              Contact Us
            </Link>
          </div>

          <div className="navigation__actions">
            <ShoppingCart />
            <Link to="/contact-us" className="navigation__cta" onClick={toggleMenu}>
              Get Started →
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
